import { useState } from 'react'

export default function useConsumptionTableController() {
  const [changedQuantities, setChangedQuantities] = useState({})
  const [saveAllError, setSaveAllError] = useState(null)

  return { saveAllError, setSaveAllError, changedQuantities, setChangedQuantities }
}
